import { useAuth } from "./hooks/useAuth";
import Login from "./Login";
import ResetPassword from "./ResetPassword";
import Dashboard from "./Dashboard";
import PageAdmin from "./PageAdmin";
import PageLanding from "./pages/PageLanding";
import ErrorBoundary from "./components/ErrorBoundary";


/**
 * Point d'entrée Bati Viz
 *
 * Flux :
 * 1. useAuth résout session + profil + tenant + rôle
 * 2. Si reset password → page ResetPassword
 * 3. Si pas de session → page Login
 * 4. Si admin sur admin.bativiz.fr → Dashboard admin (à venir)
 * 5. Sinon → Dashboard client avec tenantId
 */
export default function App() {
  const {
    session,
    profile,
    tenant,
    tenantId,
    role,
    loading,
    isReset,
    isAdmin,
    error,
    signOut,
  } = useAuth();

  // ─── Landing page commerciale (domaine racine) ───
  // Exception : si recovery en cours, on laisse passer vers ResetPassword
  const hostname = window.location.hostname;
  if ((hostname === "bativiz.fr" || hostname === "www.bativiz.fr") && !isReset) {
    return <PageLanding />;
  }

  // ─── Écran de chargement ───
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          background: "#F8FAFC",
          fontFamily: "'Inter', sans-serif",
        }}
      >
        <div
          style={{
            width: 40,
            height: 40,
            border: "4px solid #F59E0B",
            borderTopColor: "transparent",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
        <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      </div>
    );
  }

  // ─── Page reset mot de passe (lien email Supabase) ───
  if (isReset) return <ResetPassword />;

  // ─── Pas de session → Login ───
  if (!session) return <Login error={error} />;

  // ─── Erreur profil (compte désactivé, mauvais sous-domaine, etc.) ───
  if (error) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          background: "#F8FAFC",
          fontFamily: "'Inter', sans-serif",
          flexDirection: "column",
          gap: 16,
        }}
      >
        <div style={{ fontSize: 18, fontWeight: 700, color: "#0D1B2A" }}>
          Bati Viz
        </div>
        <div
          style={{
            color: "#DC2626",
            fontSize: 14,
            maxWidth: 400,
            textAlign: "center",
          }}
        >
          {error}
        </div>
        <button
          onClick={signOut}
          style={{
            padding: "8px 24px",
            background: "#0D1B2A",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          Retour au login
        </button>
      </div>
    );
  }

  // ─── Admin sur admin.bativiz.fr ───
  if (isAdmin && role === "admin") {
    return <PageAdmin profile={profile} signOut={signOut} />;
  }

  // ─── Dashboard client ───
  return (
    <ErrorBoundary>
    <Dashboard
      session={session}
      profile={profile}
      tenant={tenant}
      tenantId={tenantId}
      role={role}
      signOut={signOut}
    />
    </ErrorBoundary>
  );
}